import { render, staticRenderFns } from "./SpecialCheck.vue?vue&type=template&id=389dfa6a&scoped=true"
import script from "./SpecialCheck.vue?vue&type=script&lang=js"
export * from "./SpecialCheck.vue?vue&type=script&lang=js"
import style0 from "./SpecialCheck.vue?vue&type=style&index=0&id=389dfa6a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389dfa6a",
  null
  
)

export default component.exports